// extracted by mini-css-extract-plugin
export default {"form":"CreateAccount_form__-k-HS","error":"CreateAccount_error__j0UiQ","actions":"CreateAccount_actions__USx9D"};